import React, { useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './ProvinceCards.css'; // Import your CSS file

// Import images
import gautengImage from '../../assets/gauteng.jpg';
import kwazuluNatalImage from '../../assets/kwazulunatal.png';
import westernCapeImage from '../../assets/westerncape.png';
import easternCapeImage from '../../assets/easterncape.jpg';
import limpopoImage from '../../assets/limpopo.jpg';
import mpumalangaImage from '../../assets/mpumalanga.jpg';
import freeStateImage from '../../assets/freestate.jpg';
import northWestImage from '../../assets/northwest.jpg';
import northernCapeImage from '../../assets/northerncape.jpg';

const ProvinceCards = () => {
  const [selectedVenue, setSelectedVenue] = useState(null);

  const handleCardClick = (venue) => {
    setSelectedVenue(selectedVenue === venue ? null : venue);
  };

  const provinces = [
    { name: 'Gauteng', imageUrl: gautengImage, venueInfo: 'Information about Gauteng venue.' },
    { name: 'KwaZulu-Natal', imageUrl: kwazuluNatalImage, venueInfo: 'Information about KwaZulu-Natal venue.' },
    { name: 'Western Cape', imageUrl: westernCapeImage, venueInfo: 'Information about Western Cape venue.' },
    { name: 'Eastern Cape', imageUrl: easternCapeImage, venueInfo: 'Information about Eastern Cape venue.' },
    { name: 'Limpopo', imageUrl: limpopoImage, venueInfo: 'Information about Limpopo venue.' },
    { name: 'Mpumalanga', imageUrl: mpumalangaImage, venueInfo: 'Information about Mpumalanga venue.' },
    { name: 'Free State', imageUrl: freeStateImage, venueInfo: 'Information about Free State venue.' },
    { name: 'North West', imageUrl: northWestImage, venueInfo: 'Information about North West venue.' },
    { name: 'Northern Cape', imageUrl: northernCapeImage, venueInfo: 'Information about Northern Cape venue.' }
  ];

  const settings = {
    infinite: true,            // Carousel loops infinitely
    speed: 500,                // Speed of slide transition
    slidesToShow: 3,           // Number of slides to show
    slidesToScroll: 1,         // Number of slides to scroll
    autoplay: true,            // Enable automatic sliding
    autoplaySpeed: 3000,       // Time between each slide (in ms)
    cssEase: "linear",         // Smooth transition between slides
    arrows: false,             // Disable arrows
    pauseOnHover: false,       // Keep autoplay even when hovering
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <div className="province-container">
      <h2 className="carousel-title">Provincial Venues</h2>
      <div className="carousel">
        <Slider {...settings}>
          {provinces.map((province, index) => (
            <div
              key={index}
              className="province-card"
              onClick={() => handleCardClick(province.name)}
            >
              <div className="province-image">
                <img src={province.imageUrl} alt={province.name} />
              </div>
              <div className="province-name">
                {selectedVenue === province.name && (
                  <div className="province-info">
                    <p>{province.venueInfo}</p>
                  </div>
                )}
                <h3>{province.name}</h3>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default ProvinceCards;
